import {Form as AntdForm} from 'antd';
import FormItem from './FormItem';
import {FormItemLayouts} from './formItemLayouts';

const Form = ({onFinish, noTrimming = false, ...props}) => {
  const trimElement = (ele) => {
    switch (typeof ele) {
      case 'string':
        return ele.trim();
      case 'object':
        if (Array.isArray(ele)) {
          return ele.map((v) => trimElement(v));
        }
        if (ele === null) {
          return ele;
        }
        // eslint-disable-next-line no-case-declarations
        const newObj = {};
        Object.keys(ele).forEach((key) => {
          newObj[key] = trimElement(ele[key]);
        });
        return newObj;
      default:
        return ele;
    }
  };

  // FIXME: Not used at the moment, as implementation breaks (at least) moment objects which leads to multiple errors
  const handleFinish = (values) => {
    let trimmedValues = {...values};
    if (noTrimming === false) {
      trimmedValues = trimElement(trimmedValues);
    }

    if (onFinish) {
      onFinish(trimmedValues);
    }
  };
  return (
    <AntdForm
      {...FormItemLayouts.default}
      labelAlign={'left'}
      onFinish={onFinish}
      {...props}
    />
  );
};

Form.Item = FormItem;
Form.useForm = AntdForm.useForm;
Form.List = AntdForm.List;
Form.Provider = AntdForm.Provider;

export default Form;
